import {MeetingRoomAmenitiesByBuilding, RoomEquipment} from '@lib/store';
import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';
import {SECTION_ID_BUILDINGS} from './buildingFilter';

export const SECTION_ID_DYNAMIC_ROOM_EQUIPEMENT = 'SECTION_ID_ROOM_EQUIPEMENT';

export const constructDynamicRoomEquipementFilter = <TEntity extends {equipment: RoomEquipment[]}>(
  meetingRoomAmenitiesByBuilding: MeetingRoomAmenitiesByBuilding,
  getIconName: (id: RoomEquipment) => string,
  t: TFunction,
) => {
  const equipementWithBuildingId = Object.entries(meetingRoomAmenitiesByBuilding).flatMap(([buildingId, amenities]) => {
    const activities = amenities?.equipment ?? [];

    return activities.map((equipement) => ({
      id: `${buildingId}_${equipement}`,
      label: equipement as RoomEquipment,
      buildingId,
    }));
  });

  return constructFilter({
    sectionId: SECTION_ID_DYNAMIC_ROOM_EQUIPEMENT,
    sectionTitle: t('meeting:EquipmentTitle'),
    type: 'and',
    data: equipementWithBuildingId.map(({buildingId, id, label}) => ({
      id,
      label: t(`meetingEquipment:${label}`),
      enumValue: label,
      dynamicFilterConfig: {sectionId: SECTION_ID_BUILDINGS, filterOptionId: buildingId},
      iconName: getIconName(label),
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.equipment.includes(filter.enumValue),
  });
};
